import React, {Component} from 'react';
import PropTypes from "prop-types";
import {fabric} from "fabric";
import omit from "lodash-es/omit";
import EnumBodySilhouetteSignTypes from "./EnumBodySilhouetteSignTypes";

class Cross extends Component {
    state = { }

    static propTypes = {
        url: PropTypes.string,
        scale: PropTypes.number,
        top: PropTypes.number,
        left: PropTypes.number,
        scaleX: PropTypes.number,
        scaleY: PropTypes.number,
        angle: PropTypes.number
    }

    static defaultProps = {
        scaleX: 0.6,
        scaleY: 0.6,
        top: 200,
        left: 800,
        type: EnumBodySilhouetteSignTypes.ARROW,
    }

    componentDidMount() {
        const options = omit(this.props)
        fabric.Image.fromURL(process.env.PUBLIC_URL + '/assets/forms/arrow.png', img => {
            this.props.canvas.add(img)
        }, options)
    }

    render() {
        return null;
    }
}

export default Cross;